import { render } from "./community-card.vue?vue&type=template&id=e4ae5f2c"
import script from "./community-card.vue?vue&type=script&lang=js"
export * from "./community-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__